import {
  StructuredTableKind,
  UnknownStructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';
import {Table} from 'notebook/tables/constants/TableConstants';
import {Note} from 'notebook/util/NoteUtilConstants';
import memoizeLastCall from 'util/memoizeLastCall';

import {doesUserHavePermissionToViewTable} from './doesUserHavePermissionToViewTable';
import getAllStructuredTablesInNote from './getAllStructuredTablesInNote';

/**
 * Given a Note, we collect all StructuredTables, then apply the given filter (a table "kind").
 *
 * The tables are converted to Table objects so they can be used in the AddSamples modal or elsewhere.
 */

// The list of structured table objects is resilient to memoization. The converted tables are not!
const memoizeConvertedStructuredTables = memoizeLastCall(
  (kind: StructuredTableKind, ...tables: Array<UnknownStructuredTable>) => {
    const adapter = STRUCTURED_TABLE_PLUGIN.get(kind);
    return tables.map((t) => adapter.toTable(t));
  }
);

export default function collectSomeStructuredTablesInNote(
  note: Note,
  filter: StructuredTableKind
): Array<Table> {
  const sourceTables: Array<UnknownStructuredTable> = getAllStructuredTablesInNote(note).filter(
    (t) => t.kind === filter && doesUserHavePermissionToViewTable(t)
  );
  return memoizeConvertedStructuredTables(filter, ...sourceTables);
}
